import React from 'react';
import AboutSection1 from '../../components/about/AboutSection1';
import AboutSection2 from '../../components/about/AboutSection2';
import AboutSection3 from '../../components/about/AboutSection3';
import AboutBanner from '../../components/about/AboutBanner';
import ContactSection from '../../components/about/ContactSection';

const AboutPage = () => {
    return (
        <div className="w-full pt-[40px] md:pt-[60px] lg:pt-[80px]">
            <AboutBanner />
            <AboutSection1 />
            <AboutSection2 />
            <AboutSection3 />
            <ContactSection />
            {/*<AboutSection4 />*/}
            {/*<AboutSection5 />*/}
            {/*<AboutSection6 />*/}
        </div>
    );
};

export default AboutPage;